import { render, staticRenderFns } from "./tahsilatodemeler.vue?vue&type=template&id=345d9e96&scoped=true"
import script from "./tahsilatodemeler.vue?vue&type=script&lang=js"
export * from "./tahsilatodemeler.vue?vue&type=script&lang=js"
import style0 from "./tahsilatodemeler.vue?vue&type=style&index=0&id=345d9e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345d9e96",
  null
  
)

export default component.exports